import {
  EncounterPausedReasonCode,
  encounterPausedReasonCodeDisplay,
} from '@quromedical/fhir-common';
import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type React from 'react';
import { strings } from 'strings';
import { z } from 'zod';

export const AdmissionPausedReasonSchema = z.object({
  statusReason: z.nativeEnum(EncounterPausedReasonCode),
});
type AdmissionPausedReason = z.infer<typeof AdmissionPausedReasonSchema>;

interface AdmissionPausedReasonProps {
  onChange: (data: AdmissionPausedReason) => void;
}

const pausedReasons: EncounterPausedReasonCode[] = Object.values(
  EncounterPausedReasonCode,
);

const mapEncounterPausedReasons = (): {
  display: string;
  value: EncounterPausedReasonCode;
}[] => {
  return pausedReasons.map((reason) => ({
    display: encounterPausedReasonCodeDisplay[reason],
    value: reason,
  }));
};

export const reasonField: Field<AdmissionPausedReason> = {
  subfields: [
    {
      key: 'statusReason',
      type: 'combobox-single',
      label: strings.AdmissionPauseReasonLabel,
      fetcher: mapEncounterPausedReasons(),
    },
  ],
};

export const AdmissionPausedReason: React.FC<AdmissionPausedReasonProps> = ({
  onChange,
}) => {
  return (
    <CrudForm
      fields={[reasonField]}
      initialValues={{}}
      showSubmitButton={false}
      onChange={onChange}
      validationSchema={AdmissionPausedReasonSchema}
      cardProps={{ unsetZIndex: true }}
      hasCard={false}
      onChangeDebounceTime={0}
    />
  );
};
